import React from 'react';
import ErrorBoundary from '@sbt-web/error-boundary';
import { getSafeHTML } from '@sbt-web/utils';
import { trackEvent } from './utils/trackEvent';
import { AiDisclaimer } from './components/AiDisclaimer';
import { FAQStructuredData } from './components/FAQStructuredData';
import { ToggleDetails } from '../ToggleDetails';
import type { Faq, FaqItem } from '@sbt-web/network/types';
import classes from './index.module.scss';

interface FaqProps {
  data: Faq | null;
}

function renderText(text: string) {
  return getSafeHTML(text, { ALLOWED_TAGS: ['b'] });
}

function FaqComponent({ data }: Readonly<FaqProps>) {
  const handleToggle = (isOpen: boolean) => trackEvent(isOpen);

  if (!data?.faq?.length) {
    return null;
  }

  return (
    <section className={classes.container} data-google-interstitial="false">
      <FAQStructuredData data={data} />

      <header className={classes.heading}>
        <h2>Domande frequenti sulla tua ricerca</h2>
        <AiDisclaimer />
      </header>

      <p className={classes.intro}>{renderText(data.intro)}</p>

      <div className={classes.questions}>
        {data.faq.map((faqData: FaqItem, index: number) => (
          <ToggleDetails
            key={`${index}-${faqData.question}`}
            summary={<h3 itemProp="name">{faqData.question}</h3>}
            onDetailsToggle={handleToggle}
            detailsTestId="faq-details"
            summaryTestId="faq-summary"
            className={classes.question}
          >
            <div data-testid="faq-answer">
              <p>{renderText(faqData.answer)}</p>
            </div>
          </ToggleDetails>
        ))}
      </div>
    </section>
  );
}

export default function Faq(props: Readonly<FaqProps>) {
  return (
    <ErrorBoundary>
      <FaqComponent {...props} />
    </ErrorBoundary>
  );
}
